import styled from 'styled-components'
import { customTheme } from '../../../styles/theme'

interface IContainerProps {
  $isOpen?: boolean;
}

interface IFooterProps {
  border: string;
}

export const Container = styled.div<IContainerProps>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: ${({ $isOpen }) => $isOpen ? 'flex' : 'none'};
`

export const Blur = styled.div`
  flex: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999;

  background: rgba(23,23,23,.6);
`

export const Footer = styled.div<IFooterProps>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  
  min-height: 150px;
  width: 100%;
  padding: 50px 30px 25px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(54.4375px);
  -webkit-backdrop-filter: blur(54.4375px);
  border-top: 3px solid ${({ border }) => border};

  button {
    padding: 0 20px;
    position: absolute;
    width: fit-content;
    bottom: 30px;

    @media (max-width: ${customTheme.breakpoints[1]}) {
      width: 100%;
      bottom: 0;
      position: relative;
      max-height: 50px;
    }
  }

  @media (max-width: ${customTheme.breakpoints[1]}) {
    flex-direction: column;

    button {
      width: 100%;
      bottom: 0;
      position: relative;
      min-height: 50px;
    }
  }
`

export const Description = styled.h4`
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  width: 100%;
  justify-content: center;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    margin-bottom: 15px;
    font-size: 18px;
  }
`

export const Image = styled.img`
  position: absolute;
  top: -218px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;

  object-fit: cover;
  border-radius: 50%;
  
  width: 250px;
  height: 250px;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    top: -140px;
    width: 170px;
    height: 170px;
  }
`
export const MissionApprovalWrapper = styled.div`
  position: absolute;
  width: 100%;
  max-width: 90vw;
  top: 0;
  right: 0;
  z-index: 999;
`
